<template>
    <div class="img-container">
        <el-image
            v-for="url in urls"
            :key="url"
            :src="url"
            :lazy="true"
        ></el-image>
    </div>
</template>

<script>
export default {
    data() {
        return {
            urls: [
                require('../../../../assets/img/doc/0.jpg'),
                require('../../../../assets/img/doc/1.jpg'),
                require('../../../../assets/img/doc/2.jpg'),
                require('../../../../assets/img/doc/3.jpg'),
                require('../../../../assets/img/doc/4.jpg'),
                require('../../../../assets/img/doc/5.jpg'),
                require('../../../../assets/img/doc/6.jpg'),
                require('../../../../assets/img/doc/7.jpg'),
                require('../../../../assets/img/doc/8.jpg'),
                require('../../../../assets/img/doc/9.jpg'),
                require('../../../../assets/img/doc/10.jpg'),
                require('../../../../assets/img/doc/11.jpg'),
                require('../../../../assets/img/doc/12.jpg'),
                require('../../../../assets/img/doc/13.jpg'),
                require('../../../../assets/img/doc/14.jpg'),
                require('../../../../assets/img/doc/15.jpg'),
                require('../../../../assets/img/doc/16.jpg'),
                require('../../../../assets/img/doc/17.jpg'),
                require('../../../../assets/img/doc/18.jpg'),
                require('../../../../assets/img/doc/19.jpg'),
            ],
        }
    },
}
</script>

<style scoped lang="less">
/deep/ .el-image {
    display: block;
    min-height: 200px;
    margin-bottom: 10px;
}
.img-container{
    height:100vh;
    overflow:auto;
}
</style>
